
// src/lib/supabase.ts
import { createBrowserClient } from '@supabase/ssr'

// THIS FUNCTION IS FOR CLIENT-SIDE COMPONENTS AND HOOKS ONLY.
// FOR SERVER ACTIONS, USE `createSupabaseServerClient` from `@/lib/supabase/server`.
export function createSupabaseBrowserClient() {
  return createBrowserClient(
    process.env.NEXT_PUBLIC_SUPABASE_URL!,
    process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY!
  )
}
